const surpriseId = 39924272300099;
const pochonId = 39713295597635;

const addToCart = async (id) => {
  return fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      updates: {
        [id]: 0
      }
    })
  });
};

const removeFromCart = (id) => {
  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      items: [
        {
          id: String(id),
          quantity: 1
        }
      ]
    })
  });
};

const refresh = async () => {
  await fetch("/cart.js");

  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true
    })
  );
};

const updateCart = async (updates) => {
  await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      updates
    })
  });

  await refresh();
};

// * Adding
// * Adding
// * Adding
document.addEventListener("cart:updated", async function (event) {
  const { items, total_price } = event.detail.cart;

  if (total_price === 0) {
    return;
  }

  let updates = {};

  const jsonString = document.getElementById("cartSteps")?.innerHTML || '{"firstStepThreshold":30,"secondStepThreshold":50,"thirdStepThreshold":70,"fourthStepThreshold":80}';
  const fixedJsonString = jsonString.replace(/'/g, '"');
  const {
      firstStepThreshold,
      thirdStepThreshold,
      fourthStepThreshold
  } = JSON.parse(fixedJsonString);

  const remove = (id) => Object.assign(updates, { [`${id}`]: 0 });
  const add = (id) => Object.assign(updates, { [`${id}`]: 1 });

  // * POCHON
  const hasPochon = items.some((item) => item.id === pochonId);
  const shouldAddThePochon = total_price / 100 >= thirdStepThreshold;

  if (hasPochon && !shouldAddThePochon) {
    remove(pochonId);
  } else if (!hasPochon && shouldAddThePochon) {
    add(pochonId);
  }

  // * SUPRISE
  const hasSurprise = items.some((item) => item.id === surpriseId);
  const shouldAddTheSuprise = total_price / 100 >= fourthStepThreshold;

  if (hasSurprise && !shouldAddTheSuprise) {
    remove(surpriseId);
  } else if (!hasSurprise && shouldAddTheSuprise) {
    add(surpriseId);
  }

  // * SAMPLES
  const getSamplesToRemoves = (samples) => {
    if (total_price / 100 < thirdStepThreshold && samples.length >= 2) {
      const samplesCopy = [...samples];
      const removedSamples = samplesCopy.splice(1).map((sample) => String(sample.id));
      return removedSamples;
    } else if (total_price / 100 < firstStepThreshold && samples.length !== 0) {
      return samples.map((sample) => String(sample.id));
    } else {
      return [];
    }
  };

  const samples = items.filter((item) => item.featured_image.alt.includes("Échantillon"));
  const samplesToRemove = getSamplesToRemoves(samples);
  let samples_length = samples.length;

  if (samplesToRemove.length) {
    samplesToRemove.forEach((sample) => {
      Object.assign(updates, { [String(sample)]: 0 });
      samples_length --;
    });
  }

  if (Object.keys(updates).length > 0) {
    await updateCart(updates);
  } else {
    await refresh();
  }

  if (
    (total_price / 100 >= thirdStepThreshold && samples_length == 2) ||
    (total_price / 100 >= firstStepThreshold && total_price / 100 < thirdStepThreshold && samples_length == 1)
  ){
    window.addingSample = true;
    return;
  } else {
    window.addingSample = false;    
  }
});

// * Cleaning
// * Cleaning
// * Cleaning

document.addEventListener("cart:updated", async function (event) {
  const { items, total_price } = event.detail.cart;

  if (total_price > 0) {
    return;
  }

  const samples = items.filter((item) => item.featured_image.alt === "Échantillon").map((sample) => String(sample.id));
  const hasPochon = items.some((item) => item.id === pochonId);
  const hasSurprise = items.some((item) => item.id === surpriseId);

  if (samples.length || hasPochon || hasSurprise) {
    let updates = {};

    if (samples.length) {
      samples.forEach((id) => {
        updates[`${id}`] = 0;
      });
    }

    if (hasPochon) {
      updates[`${pochonId}`] = 0;
    }
    if (hasSurprise) {
      updates[`${surpriseId}`] = 0;
    }

    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates
      })
    });
    await fetch("/cart.js");
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true
      })
    );
  }

  await refresh();
});

// FILTERS SIDECART
function openNav() {
  document.getElementById("filtersSidebar").style.width = "500px";
}

function closeNav() {
  document.getElementById("filtersSidebar").style.width = "0";
}

// ADD CLASS IN SCROLL SIDE-MENU
let scrollpos = window.scrollY;
let header = document.getElementById("mobile-menu-drawer");

function add_class_on_scroll() {
  header.classList.add("side-menu-top-position");
}

function remove_class_on_scroll() {
  header.classList.remove("side-menu-top-position");
}

window.addEventListener("scroll", function () {
  //Here you forgot to update the value
  scrollpos = window.scrollY;

  if (scrollpos > 58) {
    add_class_on_scroll();
  } else {
    remove_class_on_scroll();
  }
});

// TEXT SIDECART

async function setNote(note) {
  await fetch("/cart/update.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify({
      note: note
    })
  });
  // 39892626767939

  await refresh();
}

var NoteModal = class extends HTMLElement {
  constructor() {
    super();
    this.input = document.querySelector("input[name=open-note-modal]");
    this.textarea = this.querySelector("textarea");
    this.inputFrom = this.querySelector("#senderName");
    this.querySelector("#submitNoteModal").addEventListener("click", this.submitNoteModal);
    this.querySelector("#closeNoteModal").addEventListener("click", this.closeNoteModal);
    this.init();
  }

  init = () => {
    const [note, from] = (window.cartNote || "").split("\nDe la part de ");
    this.textarea.value = note || "";
    this.inputFrom.value = from || "";
  };

  submitNoteModal = async () => {
    window.cartNote =
      this.textarea.value + `${this.inputFrom.value.length ? `\nDe la part de ${this.inputFrom.value}` : ""}`;
    await updateCart({ 39892626767939: 1 });
    await setNote(window.cartNote);
    this.classList.remove("show-extra-text");
  };
  closeNoteModal = async () => {
    this.input.checked = false;
    this.input.dispatchEvent(new Event("change", { bubbles: true }));
  };
};

window.customElements.define("note-modal", NoteModal);

var NoteModalCheckbox = class extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.input.addEventListener("change", this.onToggle);
    this.init();
  }

  init = () => {
    this.input.checked = window.cartNote.length > 0;
  };

  onToggle = async (e) => {
    const modal = document.querySelector("note-modal");
    const textarea = modal.querySelector("textarea");
    if (e.target.checked) {
      modal.classList.add("show-extra-text");
      textarea.setAttribute("is", "cart-note");
      textarea.setAttribute("id", "cart[note]");
    } else {
      textarea.setAttribute("is", "");
      textarea.setAttribute("id", "");
      modal.classList.remove("show-extra-text");
      await updateCart({ 39892626767939: 0 });
      if (textarea.value.length > 0) {
        textarea.value = "";
        window.cartNote = "";
        await setNote("");
      }
    }
  };
};

window.customElements.define("note-modal-checkbox", NoteModalCheckbox);
